import { render, staticRenderFns } from "./QuestionnaireEdit.vue?vue&type=template&id=485f74e0&scoped=true&lang=pug"
import script from "./QuestionnaireEdit.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireEdit.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireEdit.vue?vue&type=style&index=0&id=485f74e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f74e0",
  null
  
)

export default component.exports